import { CUSTOM_LANGUAGES_PROPERTY_TYPE_ID } from "@constants/verification-service-details-constants";
import { PageLevelTypes } from "@enums/page-level-types";
import { LocaleTypes } from "@iddataweb/idw-common-ui/enums";
import { FormattedIdwProfileProperty } from "@idw-types/data/idw-profile";
import { isNullOrUndefined, toObject } from "@utils/object-util";
import { AXNUIContent, DCUIContent, MultiLanguageWrapper } from "@iddataweb/idw-common-ui/types";
import { FormattedRpServiceConfiguration, FormattedRpServiceConfigurationProperty } from "@idw-types/data/rp-service-configuration";
import { setAXNUIAndDCUIContentPropertyValue } from "@utils/content-util";

export const getCustomLanguages = (
    pageLevel: PageLevelTypes,
    profileProperties: Array<FormattedIdwProfileProperty>,
    rpServiceProperties: Array<FormattedRpServiceConfigurationProperty> = []
): Array<LocaleTypes> => {

    let customLanguageProperty;

    if (pageLevel === PageLevelTypes.WORKFLOW && !isNullOrUndefined(profileProperties)) {
        customLanguageProperty = profileProperties.find(property => {
            return property.availableProperty.id === CUSTOM_LANGUAGES_PROPERTY_TYPE_ID && property.value && property.addedToProfile;
        });
    } else {
        customLanguageProperty = rpServiceProperties.find(property => {
            return property.propertyTypeId === CUSTOM_LANGUAGES_PROPERTY_TYPE_ID && property.value && property.addedToService;
        });
    }

    if (customLanguageProperty) {
        return getCustomLanguagesFromPropertyValue(customLanguageProperty.value);
    }

    return [];
};

export const getCustomLanguagesFromPropertyValue = (customLanguagePropertyValue: string) => {
    const localesMap = toObject<LocaleTypes>(Object.values(LocaleTypes), null);
    const customLanguagePropertyValues = customLanguagePropertyValue.split(',');
    return customLanguagePropertyValues.reduce((languages, lng) => {
        if (localesMap[lng]) {
            languages.push(localesMap[lng]);
        }
        return languages;
    }, []);
};

export const updateRpServicesAXNUIAndDCUIContentProperty = (
    isMultiLanguageEnabled: boolean,
    rpServiceConfigurationsState: Array<FormattedRpServiceConfiguration>,
    multiLanguageAXNUIContent: MultiLanguageWrapper<AXNUIContent>,
    multiLanguageDCUIContent: MultiLanguageWrapper<DCUIContent>,
    availableLanguages: Array<LocaleTypes>,
    selectedLanguage: LocaleTypes
) => {
    return rpServiceConfigurationsState.map(rpService => {
        return updateRpServiceAXNUIAndDCUIContentProperty(
            rpService,
            isMultiLanguageEnabled,
            multiLanguageAXNUIContent,
            multiLanguageDCUIContent,
            availableLanguages,
            selectedLanguage
        );
    });
};

export const updateRpServiceAXNUIAndDCUIContentProperty = (
    rpService: FormattedRpServiceConfiguration,
    isMultiLanguageEnabled: boolean,
    multiLanguageAXNUIContent: MultiLanguageWrapper<AXNUIContent>,
    multiLanguageDCUIContent: MultiLanguageWrapper<DCUIContent>,
    availableLanguages: Array<LocaleTypes>,
    selectedLanguage: LocaleTypes
): FormattedRpServiceConfiguration => {

    const properties = setAXNUIAndDCUIContentPropertyValue(
        rpService.properties,
        isMultiLanguageEnabled,
        multiLanguageAXNUIContent,
        multiLanguageDCUIContent,
        availableLanguages,
        selectedLanguage
    );

    return { ...rpService, properties };
};

